export default "__VITE_ASSET__DggJ6Qwz__"